import { render, staticRenderFns } from "./CrmCalendarFieldsSettings.vue?vue&type=template&id=165f8fe7&scoped=true"
import script from "./CrmCalendarFieldsSettings.vue?vue&type=script&lang=ts"
export * from "./CrmCalendarFieldsSettings.vue?vue&type=script&lang=ts"
import style0 from "./CrmCalendarFieldsSettings.vue?vue&type=style&index=0&id=165f8fe7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165f8fe7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('165f8fe7')) {
      api.createRecord('165f8fe7', component.options)
    } else {
      api.reload('165f8fe7', component.options)
    }
    module.hot.accept("./CrmCalendarFieldsSettings.vue?vue&type=template&id=165f8fe7&scoped=true", function () {
      api.rerender('165f8fe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmCalendarFieldsSettings.vue"
export default component.exports